import { render } from "./DocumentsIcon.vue?vue&type=template&id=3705a96c"
const script = {}
script.render = render

export default script